export default __webpack_public_path__ + "static/media/Path3391.67f12839.svg";